import { isBrowser } from '.'

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

export function updateTag(tagName, keyName, keyValue, attrName, attrValue) {
  const node = document.head.querySelector(`${tagName}[${keyName}="${keyValue}"]`)
  if (node && node.getAttribute(attrName) === attrValue) return

  // Remove and create a new tag in order to make it work with bookmarks in Safari
  if (node) {
    node.parentNode.removeChild(node)
  }
  if (typeof attrValue === 'string') {
    const nextNode = document.createElement(tagName)
    nextNode.setAttribute(keyName, keyValue)
    nextNode.setAttribute(attrName, attrValue)
    document.head.appendChild(nextNode)
  }
}

export function updateMeta(name, content) {
  updateTag('meta', 'name', name, 'content', content)
}

export function updateCustomMeta(keyName, property, content) {
  if (!keyName || !property || !content) return
  updateTag('meta', keyName, property, 'content', content)
}

export function updateLink(rel, href) {
  updateTag('link', 'rel', rel, 'href', href)
}

export function lockBodyScroll() {
  document.body.style.overflow = 'hidden'
  document.body.style.overflowX = 'hidden'
}

export function unlockBodyScroll() {
  document.body.style.overflow = ''
  document.body.style.overflowX = ''
}

export function scrollToTop() {
  isBrowser && window.scrollTo(0, 0)
}

export const replaceUrl = (replacedUrl: string) => {
  window.history.replaceState({}, document.title, replacedUrl)
}
